import React from "react";
import Title from "../Components/Elements/Title";
import Text from "../Components/Elements/Text";
import MainContainer from "../Components/Elements/MainContainer";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

interface Props {
    useHelm?: boolean;
}

const Accommodation = ({ useHelm = false} : Props) => {
    return (
        <MainContainer>
            {useHelm && (
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>H&R Wedding | Accommodation</title>
                </Helmet>
            )}
            <Title size="3">Accomodation</Title>
            <Text>Below are four recommended hotels for your stay. Accommodation works on a first-come, first-served basis. A preferential discount code is available for the Tudor Park hotel and Village hotel. Details of accommodation options can be found below.</Text>
            
            <div className="py-5">
                <Title size="2" className="pt-3">Tudor Park Marriott Hotel & Country Club</Title>
                <Text><b>Note:</b> Tudor Park is the closest hotel to the venue. Whilst we do have a discount code to supply you below, it may well be more cost effective to become a <a className="text-blue-600 underline" href="https://www.marriott.com/en-gb/loyalty.mi" target="_blank" rel="noreferrer">Marriot bonvoy member</a>, which generally provides the most preferrable rates. Sign up is free.</Text>
                <Text>Address: Ashford Road, Bearsted, Maidstone, ME14 4NQ</Text>
                <Text><b>Discount code: T3687</b></Text>
                <div className="flex pt-5 justify-center w-full">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2511.123456789!2d0.123456789!3d51.123456789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xeb036fcade7a373f!2sDelta%20Hotels%20Tudor%20Park%20Country%20Club!5e0!3m2!1sen!2suk!4v1234567890"
                        className="w-full min-h-[200px] max-h-[350px] border-0"
                        allowFullScreen={true}
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Delta Hotels Tudor Park Country Club"
                    ></iframe>
                </div>
                
            </div>

            <div className="py-5">
                <Title size="2" className="pt-3">Village Hotel Maidstone</Title>
                <Text>Address: Castle View, Forstal Rd ME14 3AQ</Text>
                <Text><b>Discount code: ORCHD</b></Text>
                <div className="flex pt-5 justify-center">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2511.2307870524123!2d0.5096353!3d51.2957396!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47df33ae8a5b927d%3A0x84c0802368aeeec9!2sVillage%20Hotel%20Maidstone!5e0!3m2!1sen!2suk!4v1234567890"
                        className="w-full min-h-[200px] max-h-[350px] border-0"
                        allowFullScreen={true}
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Village Hotel Maidstone"
                    ></iframe>
                </div>
            </div>  

            <div className="py-5">
                <Title size="2" className="pt-3">The Potting Shed</Title>
                <Text>Address: Horseshoes Ln, Langley, Maidstone ME17 3LZ</Text>
                <div className="flex pt-5 justify-center">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2508.3036078659636!2d0.5823707!3d51.2362529!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47df2e40a45dd71f%3A0xfbc4c5d79cfb482e!2sThe%20Potting%20Shed!5e0!3m2!1sen!2suk!4v1234567890"
                        className="w-full min-h-[200px] max-h-[350px] border-0"
                        allowFullScreen={true}
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="The Potting Shed"
                    ></iframe>
                </div>
            </div>  

            <div className="py-5">
                <Title size="2" className="pt-3">Mercure Maidstone Great Danes Hotel</Title>
                <Text>Address: Hollingbourne, Maidstone ME17 1RE</Text>
                <div className="flex pt-5 justify-center">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2509.944117452469!2d0.5912538!3d51.244897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xef3d557ab8d01d5f!2sMercure%20Maidstone%20Great%20Danes%20Hotel!5e0!3m2!1sen!2suk!4v1234567890"
                        className="w-full min-h-[200px] max-h-[350px] border-0"
                        allowFullScreen={true}
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Mercure Maidstone Great Danes Hotel"
                    ></iframe>
                </div>
            </div>  
            { useHelm && <Text className="pt-4">
                <Link
                    to="/app"
                    className="bg-blue-500 hover:bg-blue-700 font font-lora text-white font-bold py-2 px-4 rounded my-2 inline-block text-center"
                >
                    Back to home
                </Link>
            </Text>}
        </MainContainer>
    );
}

export default Accommodation;